// extracted by mini-css-extract-plugin
export default {"fr-view":"CommentReply_fr-view__zrAD9","header":"CommentReply_header__ZOPx6"};